module.exports = __webpack_public_path__ + "quotezone-ui/img/mortice-lock-white.2bbc0964.png";